
import React, { useState } from 'react';
import styles from './Form.css';

export default function Form() {
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);

  const handleEmailChange = (event) => {
    const inputEmail = event.target.value;
    setEmail(inputEmail);
    setIsValidEmail(emailPattern.test(inputEmail));
  };

  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  return (
    <div className='form-container'>
      <form action="" className='form-sub-container'>
        <input
          type="email"
          id="email"
          value={email}
          onChange={handleEmailChange}
          autoComplete='off'
          placeholder='Enter your email'
        />

        {!isValidEmail && email.trim() !== '' && ( // Add condition to check for invalid email and non-empty input
          <p className='error-message'>Email is not valid.</p>
        )}
        <button>Contact Us</button>
      </form>
    </div>
  );
}
